import { BlockStack } from "@shopify/polaris";
import clsx from "clsx";
import moment from "moment";
import React from "react";
import logo from "../../assets/whatsapp-preview/limited-time-offer-logo.svg";

export const LimitedTimeOfferPreview = ({
  headerMedia,
  limitedTimeOffer,
  copyCodeButton,
  isInPanel,
}) => {
  const { text, expirationDate, expirationDelayInMinutes } =
    limitedTimeOffer || {};
  const invalidExpirationDate =
    expirationDate && moment(expirationDate).isSameOrBefore(moment());
  let expirationLabel = invalidExpirationDate
    ? "Select an expiration date in the future"
    : null;
  if (!expirationLabel) {
    const duration = expirationDate
      ? moment.duration(moment(expirationDate).diff(moment()))
      : moment.duration({ minutes: expirationDelayInMinutes });
    expirationLabel = duration
      ? `Ends in ${duration.humanize()}`
      : "Select an expiration date or a delay";
  }

  const _hasHeaderMedia = ["image", "video"].includes(headerMedia?.type);
  return (
    <BlockStack>
      <div
        className={clsx(
          "limited-time-offer-preview flex flex-row items-center",
          { "no-header": !_hasHeaderMedia },
        )}
      >
        <div className="limited-time-offer-logo">
          <img className="object-cover" src={logo} alt="logo du trigger" />
        </div>
        <div className="flex flex-col">
          <span className="limited-time-offer-text">{text}</span>
          {isInPanel && (
            <span
              className={clsx("limited-time-offer-expiration-date", {
                "text-red-600":
                  (!expirationDate && !expirationDelayInMinutes) ||
                  invalidExpirationDate,
              })}
            >
              {expirationLabel}
            </span>
          )}
          {!isInPanel && (
            <span className={clsx("limited-time-offer-expiration-date")}>
              Expiration date
            </span>
          )}
          {copyCodeButton?.text && (
            <span className="limited-time-offer-copy-code">
              Code: {copyCodeButton.text}
            </span>
          )}
        </div>
      </div>
    </BlockStack>
  );
};
